import Grid from '@mui/material/Grid';
import dashboardImage from '../../assets/images/dashboard/backoffice.png';

const DashboardPage = () => {
  return (
    <div>
      <Grid container className='dashboard-container'>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 6 }} className='dashboard-text'>
          <h1>¡Hola!</h1>
          <p>
            Te damos la bienvenida a tu tablero principal, próximamente podrás encontrar información
            y estadísticas necesarias para brindar un mejor servicio a tus clientes.
          </p>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 6 }} className='image-container'>
          <img src={dashboardImage} alt='Dashboard' />
        </Grid>
      </Grid>
    </div>
  );
};

export default DashboardPage;
